import { FormGroup, TextInput } from '@allurion/ui';
import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { useIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import { z } from 'zod';

import { TrackedButton } from 'src/analytics/TrackedUI';
import globalMessages from 'src/messages/global.messages';
import * as appRoutes from 'src/utils/appRoutes';

import messages from './login.messages';

import styles from './LoginForm.module.scss';

type FormValues = {
  email: string;
  password: string;
};

type Props = {
  initialValues: FormValues;
  onSubmit: (values: FormValues) => void;
};

export function LoginForm({ initialValues, onSubmit }: Props) {
  const intl = useIntl();

  const LoginFormSchema = z.object({
    email: z
      .string()
      .nonempty(intl.formatMessage(globalMessages.required))
      .email(intl.formatMessage(globalMessages.notValidEmail)),
    password: z.string().nonempty(intl.formatMessage(globalMessages.required)),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<FormValues>({
    resolver: zodResolver(LoginFormSchema),
    defaultValues: initialValues,
  });

  return (
    <form className={styles.form} onSubmit={handleSubmit(onSubmit)}>
      <FormGroup label={intl.formatMessage(messages.email)} error={errors.email?.message}>
        <TextInput
          type="email"
          placeholder={intl.formatMessage(messages.email)}
          {...register('email')}
        />
      </FormGroup>
      <FormGroup label={intl.formatMessage(messages.password)} error={errors.password?.message}>
        <TextInput
          type="password"
          placeholder={intl.formatMessage(messages.password)}
          {...register('password')}
        />
      </FormGroup>
      <div className={styles.controls}>
        <TrackedButton
          label={intl.formatMessage(messages.submitBtn)}
          type="submit"
          variant="secondary"
          trackLabel="submit-login-form"
        />
        <Link className={styles.styedLink} to={appRoutes.resetPasswordRoute}>
          {intl.formatMessage(messages.resetPassword)}
        </Link>
      </div>
    </form>
  );
}
